import { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const API = process.env.REACT_APP_BACKEND_URL ? `${process.env.REACT_APP_BACKEND_URL}/api` : '/api';

const ProfileBadges = ({ userId, size = "sm" }) => {
  const navigate = useNavigate();
  const [badges, setBadges] = useState([]);
  const [totalBadges, setTotalBadges] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (userId) {
      fetchBadges();
    }
  }, [userId]);

  const fetchBadges = async () => {
    try {
      const response = await axios.get(`${API}/profile/${userId}/badges`);
      setBadges(response.data.display_badges || []);
      setTotalBadges(response.data.total_badges || 0);
    } catch (error) {
      console.error("Error fetching profile badges:", error);
    } finally {
      setLoading(false);
    }
  };

  if (loading || badges.length === 0) {
    return null; // Don't show anything if no badges
  }

  const sizeClasses = {
    sm: "text-lg",
    md: "text-xl",
    lg: "text-2xl"
  };

  return (
    <div 
      className="flex items-center gap-1 cursor-pointer hover:opacity-80 transition-opacity"
      onClick={() => navigate('/achievements')}
      title={`${totalBadges} badges earned - Click to view all`}
    >
      {badges.map((badge, index) => (
        <span 
          key={badge.badge_id || index} 
          className={`${sizeClasses[size]} drop-shadow-lg`}
          title={badge.name}
        >
          {badge.icon}
        </span>
      ))}
      {totalBadges > 3 && (
        <span className="text-gray-500 text-xs ml-1">+{totalBadges - 3}</span>
      )}
    </div>
  );
};

export default ProfileBadges;
